/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the difference between an anagram and an unscramble?`)
};

const es_wu_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre un anagrama y descifrar letras?`)
};

const de_wu_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen einem Anagramm und einem Entwirren?`)
};

const nl_wu_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen een anagram en ontwarren?`)
};

const fr_wu_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre un anagramme et un déchiffrage ?`)
};

const it_wu_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra un anagramma e uno sblocco di lettere?`)
};

const pt_br2_wu_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre um anagrama e um desembaralhamento de letras?`)
};

const pt_wu_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre um anagrama e um desbaralhamento?`)
};

const ja_wu_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アナグラムと文字の並べ替えの違いは何ですか？`)
};

const zh_wu_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`易位构词和字母重组有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_hub_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_hub_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_hub_faq2_q", locale)
	if (locale === "en") return en_wu_hub_faq2_q(inputs)
	if (locale === "es") return es_wu_hub_faq2_q(inputs)
	if (locale === "de") return de_wu_hub_faq2_q(inputs)
	if (locale === "nl") return nl_wu_hub_faq2_q(inputs)
	if (locale === "fr") return fr_wu_hub_faq2_q(inputs)
	if (locale === "it") return it_wu_hub_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_wu_hub_faq2_q(inputs)
	if (locale === "pt") return pt_wu_hub_faq2_q(inputs)
	if (locale === "ja") return ja_wu_hub_faq2_q(inputs)
	return zh_wu_hub_faq2_q(inputs)
};